// result cards
export const AREA_OF_STUDY_DISPLAY_LIMIT = 2;
